/* ============================================================
   Sertarul de cos — recomandari pe raft + nivelul de cadou

   Doua lucruri traiesc aici:
   1. raftul „Adauga si" (cross-sell), cu sageti, dupa modelul Vivendo;
   2. sincronizarea produsului cadou cu pragul din setari.

   Nota de arhitectura: Dawn re-randeaza sertarul inlocuind `innerHTML`, deci
   orice ascultator pus pe un nod dinauntru moare la prima schimbare de
   cantitate. De aceea totul se re-initializeaza dintr-un MutationObserver pe
   `#CartDrawer` (nodul ala nu e niciodata inlocuit, doar continutul lui).
   ============================================================ */
(function () {
  'use strict';

  // ── formatarea sumelor ────────────────────────────────────────────────────
  // NU se scrie „lei" in cod si nu se foloseste Intl: magazinul vinde si in
  // EUR/HUF, cu alt separator si alta pozitie a simbolului. Sablonul vine din
  // `shop.money_format`, pus de Liquid pe <cart-drawer data-money-format>.

  var DEFAULT_FORMAT = '{{amount_with_comma_separator}} lei';

  function moneyFormatString() {
    var el = document.querySelector('cart-drawer');
    return (el && el.dataset.moneyFormat) || DEFAULT_FORMAT;
  }

  function withDelimiters(value, precision, thousands, decimal) {
    if (isNaN(value)) value = 0;
    var parts = value.toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function money(cents) {
    var value = cents / 100;
    return moneyFormatString().replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_no_decimals':
          return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(value, 2, "'", '.');
        default:
          return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ── re-randarea sertarului ────────────────────────────────────────────────

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var doc;

        if (sections['cart-drawer']) {
          doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('#CartDrawer');
          var oldDrawer = document.getElementById('CartDrawer');
          if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;

          // `is-empty` sta pe <cart-drawer>, in afara nodului inlocuit.
          var wrapper = document.querySelector('cart-drawer');
          var newWrapper = doc.querySelector('cart-drawer');
          if (wrapper && newWrapper) {
            wrapper.classList.toggle('is-empty', newWrapper.classList.contains('is-empty'));
          }
        }

        if (sections['cart-icon-bubble']) {
          doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = doc.querySelector('.shopify-section');
          var oldBubble = document.getElementById('shopify-section-cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }
      });
  }

  // ── nivelul de cadou ──────────────────────────────────────────────────────
  // Cadoul se adauga singur cand valoarea REALA a cosului (fara liniile de
  // cadou) trece pragul, si se scoate singur cand coboara sub el.
  //
  // Scaderea liniilor de cadou nu e cosmetica: fara ea cadoul se auto-
  // intretine — intra in cos, umfla totalul, si tine pragul „atins" chiar
  // dupa ce clientul scoate produsele reale.

  var giftBusy = false;

  // Se ridica o singura data, cand adaugarea reuseste dar linia nu iese gratuita.
  // Fara el, ciclul „adauga → nu e 0 → scoate → e iar peste prag → adauga" nu se
  // mai opreste niciodata, si fiecare tura costa trei cereri la Shopify.
  var giftUnavailable = false;

  function giftConfig() {
    var el = document.querySelector('cart-drawer');
    if (!el || !el.dataset.giftVariant || !el.dataset.giftThreshold) return null;
    return {
      variantId: parseInt(el.dataset.giftVariant, 10),
      threshold: parseInt(el.dataset.giftThreshold, 10),
    };
  }

  function syncGift() {
    var cfg = giftConfig();
    if (!cfg || giftBusy) return Promise.resolve(false);

    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var giftLines = cart.items.filter(function (i) {
          return i.properties && i.properties._cadou;
        });
        var giftValue = giftLines.reduce(function (s, i) {
          return s + i.final_line_price;
        }, 0);
        var spent = cart.total_price - giftValue;

        if (spent >= cfg.threshold && giftLines.length === 0 && !giftUnavailable) {
          giftBusy = true;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: cfg.variantId, quantity: 1, properties: { _cadou: 'da' } }],
            }),
          })
            .then(function (r) {
              // Produs epuizat sau nepublicat: nu insistam, nivelul ramane
              // doar promisiune vizuala pana se schimba produsul.
              if (!r.ok) {
                giftBusy = false;
                return false;
              }
              // PLASA DE SIGURANTA: linia devine 0 lei dintr-o reducere automata
              // Shopify („Cadou 300 lei"), nu din pretul produsului. Reducerea
              // poate sa NU se aplice — de exemplu cand in cos e si o promotie
              // care nu se combina cu reduceri pe produs. In cazul ala am pune
              // pe factura un „cadou" de 39,99 lei. Verificam si, daca nu e
              // gratuit, il scoatem: mai bine lipseste decat sa fie taxat.
              return fetch('/cart.js')
                .then(function (rr) {
                  return rr.json();
                })
                .then(function (after) {
                  var line = after.items.filter(function (i) {
                    return i.properties && i.properties._cadou;
                  })[0];
                  if (line && line.final_line_price > 0) {
                    giftUnavailable = true;
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: line.key, quantity: 0 }),
                    }).then(function () {
                      giftBusy = false;
                      return true;
                    });
                  }
                  giftBusy = false;
                  return true;
                });
            })
            .catch(function () {
              giftBusy = false;
              return false;
            });
        }

        if (spent < cfg.threshold && giftLines.length > 0) {
          giftBusy = true;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftLines[0].key, quantity: 0 }),
          })
            .then(function () {
              giftBusy = false;
              return true;
            })
            .catch(function () {
              giftBusy = false;
              return false;
            });
        }

        // Mai mult de o linie de cadou (ex. adaugata manual): pastram una.
        if (giftLines.length > 1) {
          giftBusy = true;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftLines[1].key, quantity: 0 }),
          })
            .then(function () {
              giftBusy = false;
              return true;
            })
            .catch(function () {
              giftBusy = false;
              return false;
            });
        }

        return false;
      })
      .catch(function () {
        giftBusy = false;
        return false;
      });
  }

  // Ruleaza sincronizarea si re-randeaza doar daca s-a schimbat ceva.
  // Pe pagina de cos nu ajunge re-randarea sertarului: liniile si totalurile
  // paginii sunt alte sectiuni, deci acolo reincarcam.
  function syncGiftAndRefresh() {
    return syncGift().then(function (changed) {
      if (!changed) return;
      if (document.getElementById('main-cart-items')) {
        window.location.reload();
        return;
      }
      return refreshDrawer();
    });
  }

  // ── raftul de recomandari ─────────────────────────────────────────────────

  function initCrossSell() {
    var container = document.getElementById('cart-cross-sell-container');
    if (!container || container.dataset.loaded) return;
    container.dataset.loaded = '1';

    var productId = container.dataset.productId;
    if (!productId) return;

    var cfg = giftConfig();

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            return { products: data.products || [], cart: cart };
          });
      })
      .then(function (res) {
        // Re-interogam din DOM: sertarul se poate re-randa intre pornirea
        // cererii si sosirea raspunsului, iar referinta din closure e stearsa.
        container = document.getElementById('cart-cross-sell-container');
        if (!container) return;

        var inCart = {};
        res.cart.items.forEach(function (i) {
          inCart[i.product_id] = true;
        });

        var products = res.products
          .filter(function (p) {
            if (inCart[p.id]) return false;
            if (!p.variants || !p.variants.length) return false;
            if (!p.variants[0].available) return false;
            if (cfg) {
              var isGift = p.variants.some(function (v) {
                return v.id === cfg.variantId;
              });
              if (isGift) return false;
            }
            return true;
          })
          .slice(0, 8);

        if (!products.length) {
          var wrap = container.closest('.jk-cd__upsells');
          if (wrap) wrap.style.display = 'none';
          return;
        }

        container.innerHTML = products
          .map(function (p) {
            var v = p.variants[0];
            // ATENTIE: in Ajax API (`/recommendations/products.json`) `images`
            // e un tablou de STRING-uri cu URL-uri, nu de obiecte. `p.images[0].src`
            // da undefined, iar `.replace` pe undefined arunca TypeError — inghitit
            // de `.catch` si fara nimic in consola. De asta cross-sell-ul nu a mers
            // niciodata pana in aprilie.
            var imgSrc = p.images && p.images.length
              ? String(p.images[0]).replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_400x400$1$2')
              : '';
            var url = escapeHtml(p.url || '/products/' + p.handle);
            var title = escapeHtml(p.title);

            return (
              '<div class="jk-cd-mini">' +
              (imgSrc
                ? '<a href="' + url + '" tabindex="-1" aria-hidden="true"><img class="jk-cd-mini__img" src="' +
                  escapeHtml(imgSrc) + '" alt="" loading="lazy" width="140" height="140"></a>'
                : '<span class="jk-cd-mini__img"></span>') +
              '<a class="jk-cd-mini__title" href="' + url + '">' + title + '</a>' +
              '<div class="jk-cd-mini__price">' + money(v.price) + '</div>' +
              '<button class="jk-cd-mini__add" type="button" data-variant-id="' + v.id + '">Adauga</button>' +
              '</div>'
            );
          })
          .join('');

        bindRail(container);
      })
      .catch(function () {
        var c = document.getElementById('cart-cross-sell-container');
        var wrap = c && c.closest('.jk-cd__upsells');
        if (wrap) wrap.style.display = 'none';
      });
  }

  function bindRail(rail) {
    var wrap = rail.closest('.jk-cd__rail-wrap');
    if (!wrap) return;

    var prev = wrap.querySelector('[data-cross-prev]');
    var next = wrap.querySelector('[data-cross-next]');

    function step() {
      var card = rail.querySelector('.jk-cd-mini');
      return card ? card.offsetWidth + 10 : rail.clientWidth / 3;
    }

    function updateArrows() {
      // 2px toleranta: latimile fractionare din `calc((100% - 2rem)/3)` fac
      // scrollLeft maxim sa nu ajunga niciodata exact la scrollWidth-clientWidth.
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.hidden = rail.scrollLeft <= 2;
      if (next) next.hidden = max <= 2 || rail.scrollLeft >= max - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    rail.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    rail.querySelectorAll('.jk-cd-mini__add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = '...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            btn.classList.add('is-done');
            btn.textContent = 'Adaugat';
            return syncGift();
          })
          .then(function () {
            return refreshDrawer();
          })
          .catch(function () {
            btn.disabled = false;
            btn.classList.remove('is-done');
            btn.textContent = label;
          });
      });
    });
  }

  // ── initializare si re-initializare ───────────────────────────────────────

  var initTimer = null;

  function initAll() {
    // Debounce: Dawn poate inlocui si `#CartDrawer`, si `.drawer__inner` in
    // aceeasi actualizare, iar fara asta pornesc doua runde de /cart.js.
    clearTimeout(initTimer);
    initTimer = setTimeout(function () {
      initCrossSell();
      syncGiftAndRefresh();
    }, 200);
  }

  // Observatorul de pe `.drawer__inner` trebuie recreat de fiecare data cand
  // `renderContents()` distruge si reface nodul.
  var innerObserver = null;

  function attachInnerObserver() {
    if (innerObserver) innerObserver.disconnect();
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return;
    innerObserver = new MutationObserver(initAll);
    // `childList` fara `subtree`: randarea recomandarilor scrie in
    // `#cart-cross-sell-container`, adanc in arbore, si ar declansa la infinit.
    innerObserver.observe(inner, { childList: true });
  }

  function boot() {
    initCrossSell();
    syncGiftAndRefresh();
    attachInnerObserver();

    // `#CartDrawer` nu e inlocuit niciodata — doar continutul lui.
    var cartDrawerEl = document.getElementById('CartDrawer');
    if (cartDrawerEl) {
      new MutationObserver(function () {
        attachInnerObserver();
        initAll();
      }).observe(cartDrawerEl, { childList: true });
    }

    // Pagina de cos: `main-cart-items` se re-randeaza separat.
    var mainCart = document.getElementById('main-cart-items');
    if (mainCart) {
      new MutationObserver(function () {
        clearTimeout(initTimer);
        initTimer = setTimeout(syncGiftAndRefresh, 300);
      }).observe(mainCart, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
